import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  loadThemeColors(theme: any) {
    return new Promise<void>((resolve) => {
      let colors = {};
      if (theme == 'classic') {
        colors = {
          '--color-brand-01-lightest': '#d7f0fe',
          '--color-brand-01-lighter': '#9cd8fc',
          '--color-brand-01-light': '#6bc5fa',
          '--color-brand-01-dark': '#013f65',
          '--color-brand-01-darker': '#002944',
          '--color-brand-01-darkest': '#00182b',
          '--color-brand-01-base': '#045b8f',
          '--color-brand-02-base': '#045b8f',
          '--color-brand-03-base': '#045b8f',
          '--color-neutral-light-00': '#ffffff',
          '--color-neutral-light-05': '#f2f2f2',
          '--color-neutral-light-10': '#e5e5e5',
          '--color-neutral-light-20': '#cccccc',
          '--color-neutral-light-30': '#b2b2b2',
          '--color-neutral-dark-70': '#4d4d4d',
          '--color-neutral-dark-80': '#363636',
          '--color-neutral-dark-90': '#1a1a1a',
          '--color-neutral-dark-95': '#0d0d0d',
          '--color-neutral-mid-40': '#999999',
          '--color-neutral-mid-60': '#666666',
          '--color-primary': '#045b8f',
          '--color-secondary': '#045b8f',
          '--color-tertiary': '#045b8f',
        };
      } else if (theme == 'sunset') {
        colors = {
          '--color-brand-01-lightest': '#ffebee',
          '--color-brand-01-lighter': '#ef9a9a',
          '--color-brand-01-light': '#ef5350',
          '--color-brand-01-dark': '#a5131a',
          '--color-brand-01-darker': '#5d0d11',
          '--color-brand-01-darkest': '#400a08',
          '--color-brand-01-base': '#c20c18',
          '--color-brand-02-base': '#c20c18',
          '--color-brand-03-base': '#c20c18',
          '--color-neutral-light-00': '#ffffff',
          '--color-neutral-light-05': '#f2f2f2',
          '--color-neutral-light-10': '#e5e5e5',
          '--color-neutral-light-20': '#cccccc',
          '--color-neutral-light-30': '#b2b2b2',
          '--color-neutral-dark-70': '#4d4d4d',
          '--color-neutral-dark-80': '#363636',
          '--color-neutral-dark-90': '#1a1a1a',
          '--color-neutral-dark-95': '#0d0d0d',
          '--color-neutral-mid-40': '#999999',
          '--color-neutral-mid-60': '#666666',
          '--color-primary': '#c20c18',
          '--color-secondary': '#c20c18',
          '--color-tertiary': '#c20c18',
        };
      } /*else if (theme == 'dark') {
        colors = {
          '--color-brand-01-lightest': '#051F31',
          '--color-brand-01-lighter': '#004064',
          '--color-brand-01-light': '#00659A',
          '--color-brand-01-dark': '#3DADFA',
          '--color-brand-01-darker': '#AFD3FA',
          '--color-brand-01-darkest': '#E3EEFB',
          '--color-brand-01-base': '#0079B8',
          '--color-brand-02-base': '#0079B8',
          '--color-brand-03-base': '#0079B8',
          '--color-neutral-light-00': '#1C1C1C',
          '--color-neutral-light-05': '#202020',
          '--color-neutral-light-10': '#2B2B2B',
          '--color-neutral-light-20': '#3B3B3B',
          '--color-neutral-light-30': '#5A5A5A',
          '--color-neutral-dark-70': '#C1C1C1',
          '--color-neutral-dark-80': '#363636',
          '--color-neutral-dark-90': '#EEEEEE',
          '--color-neutral-dark-95': '#FBFBFB',
          '--color-neutral-mid-40': '#9da7a9',
          '--color-neutral-mid-60': '#6e7c7f',
          '--color-widget-color-default': '#EEEEEE',
          '--color-primary': '#0079B8',
          '--color-secondary': '#0079B8',
          '--color-tertiary': '#0079B8',
        };
      } else if (theme == 'dark-sunset') {
        colors = {
          '--color-brand-01-lightest': '#EF9A9A',
          '--color-brand-01-lighter': '#EF9A9A',
          '--color-brand-01-light': '#EF5350',
          '--color-brand-01-dark': '#A5131A',
          '--color-brand-01-darker': '#EEEEEE',
          '--color-brand-01-darkest': '#400A08',
          '--color-brand-01-base': '#C20C18',
          '--color-brand-02-base': '#C20C18',
          '--color-brand-03-base': '#C20C18',
          '--color-neutral-light-00': '#1C1C1C',
          '--color-neutral-light-05': '#202020',
          '--color-neutral-light-10': '#2B2B2B',
          '--color-neutral-light-20': '#3B3B3B',
          '--color-neutral-light-30': '#5A5A5A',
          '--color-neutral-dark-70': '#C1C1C1',
          '--color-neutral-dark-80': '#363636',
          '--color-neutral-dark-90': '#EEEEEE',
          '--color-neutral-dark-95': '#FBFBFB',
          '--color-neutral-mid-40': '#9da7a9',
          '--color-neutral-mid-60': '#6e7c7f',
          '--color-widget-color-default': '#EEEEEE',
          '--color-primary': '#C20C18',
          '--color-secondary': '#C20C18',
          '--color-tertiary': '#C20C18',
        };
      }*/

      this.setThemeColors(colors);
      resolve();
    });
  }

  private setThemeColors(colors: any) {
    for (const key in colors) {
      if (colors.hasOwnProperty(key)) {
        document.documentElement.style.setProperty(key, colors[key]);
      }
    }
  }
}
